import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import esCommon from "../i18n/locales/es/common.json";
import enCommon from "../i18n/locales/en/common.json";
import deCommon from "../i18n/locales/de/common.json";
import esAuth from "../i18n/locales/es/auth.json";
import enAuth from "../i18n/locales/en/auth.json";
import deAuth from "../i18n/locales/de/auth.json";
import esUsers from "../i18n/locales/es/users.json";
import enUsers from "../i18n/locales/en/users.json";
import deUsers from "../i18n/locales/de/users.json";
import esAudit from "../i18n/locales/es/audit.json";
import enAudit from "../i18n/locales/en/audit.json";
import deAudit from "../i18n/locales/de/audit.json";
import esErrors from "../i18n/locales/es/errors.json";
import enErrors from "../i18n/locales/en/errors.json";
import deErrors from "../i18n/locales/de/errors.json";
// Phase 2 namespace scaffolds (empty {} shells; populated by Wave 2 frontend tasks).
import esTemplates from "../i18n/locales/es/templates.json";
import enTemplates from "../i18n/locales/en/templates.json";
import deTemplates from "../i18n/locales/de/templates.json";
import esPositions from "../i18n/locales/es/positions.json";
import enPositions from "../i18n/locales/en/positions.json";
import dePositions from "../i18n/locales/de/positions.json";
import esQuestionBank from "../i18n/locales/es/question-bank.json";
import enQuestionBank from "../i18n/locales/en/question-bank.json";
import deQuestionBank from "../i18n/locales/de/question-bank.json";
import esWizard from "../i18n/locales/es/wizard.json";
import enWizard from "../i18n/locales/en/wizard.json";
import deWizard from "../i18n/locales/de/wizard.json";
// Phase 3 candidate surface namespace (Plan 03-05).
import esCandidate from "../i18n/locales/es/candidate.json";
import enCandidate from "../i18n/locales/en/candidate.json";
import deCandidate from "../i18n/locales/de/candidate.json";
// Phase 3 admin candidate-review namespace (Plan 03-07).
import esAdminCandidates from "../i18n/locales/es/admin-candidates.json";
import enAdminCandidates from "../i18n/locales/en/admin-candidates.json";
import deAdminCandidates from "../i18n/locales/de/admin-candidates.json";
// Phase 3 admin settings / compliance namespace (Plan 03-08).
import esAdminSettings from "../i18n/locales/es/admin-settings.json";
import enAdminSettings from "../i18n/locales/en/admin-settings.json";
import deAdminSettings from "../i18n/locales/de/admin-settings.json";
// Phase 4 candidate Stage 2 surface namespace (Plan 04-06).
import esCandidateStage2 from "../i18n/locales/es/candidate-stage2.json";
import enCandidateStage2 from "../i18n/locales/en/candidate-stage2.json";
import deCandidateStage2 from "../i18n/locales/de/candidate-stage2.json";
// Phase 4 HR Stage 2 decision-support namespace (Plan 04-07).
import esRubric from "../i18n/locales/es/rubric.json";
import enRubric from "../i18n/locales/en/rubric.json";
import deRubric from "../i18n/locales/de/rubric.json";
// Phase 4 Hiring Manager finalist namespace (Plan 04-08).
import esHm from "../i18n/locales/es/hm.json";
import enHm from "../i18n/locales/en/hm.json";
import deHm from "../i18n/locales/de/hm.json";
// Phase 4 super_admin cross-domain overview namespace (Plan 04-09).
import esOverview from "../i18n/locales/es/overview.json";
import enOverview from "../i18n/locales/en/overview.json";
import deOverview from "../i18n/locales/de/overview.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        common: esCommon,
        auth: esAuth,
        users: esUsers,
        audit: esAudit,
        errors: esErrors,
        templates: esTemplates,
        positions: esPositions,
        "question-bank": esQuestionBank,
        wizard: esWizard,
        candidate: esCandidate,
        "admin-candidates": esAdminCandidates,
        "admin-settings": esAdminSettings,
        "candidate-stage2": esCandidateStage2,
        rubric: esRubric,
        hm: esHm,
        overview: esOverview,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        users: enUsers,
        audit: enAudit,
        errors: enErrors,
        templates: enTemplates,
        positions: enPositions,
        "question-bank": enQuestionBank,
        wizard: enWizard,
        candidate: enCandidate,
        "admin-candidates": enAdminCandidates,
        "admin-settings": enAdminSettings,
        "candidate-stage2": enCandidateStage2,
        rubric: enRubric,
        hm: enHm,
        overview: enOverview,
      },
      de: {
        common: deCommon,
        auth: deAuth,
        users: deUsers,
        audit: deAudit,
        errors: deErrors,
        templates: deTemplates,
        positions: dePositions,
        "question-bank": deQuestionBank,
        wizard: deWizard,
        candidate: deCandidate,
        "admin-candidates": deAdminCandidates,
        "admin-settings": deAdminSettings,
        "candidate-stage2": deCandidateStage2,
        rubric: deRubric,
        hm: deHm,
        overview: deOverview,
      },
    },
    fallbackLng: "es",
    supportedLngs: ["es", "en", "de"],
    interpolation: { escapeValue: false },
    react: {
      // BUG-003: lazy-chunked routes capture stale t() refs without bindI18n.
      bindI18n: "languageChanged loaded added",
    },
    // BUG-003: all 3 locales loaded at boot so first navigation to a lazy route
    // never renders the EN fallback while DE/ES finishes loading.
    preload: ["es", "en", "de"],
    ns: ["common", "auth", "users", "audit", "errors", "templates", "positions", "question-bank", "wizard", "candidate", "admin-candidates", "admin-settings", "candidate-stage2", "rubric", "hm", "overview"],
    defaultNS: "common",
  });

export default i18n;
